import { useMediaQuery } from '@mui/material';
import { Box, Grid, useTheme } from '@mui/material';
import React from 'react'
import { TypographyText ,CardHeaderavtarHeading,} from '../../Reuse/Reuse';
import { containerStyles4 } from './VissionMission';
import img1 from '../../Assets/10.png'
import img2 from '../../Assets/2.png'
import img3 from '../../Assets/istockphoto-493302504-612x612.jpg'
import img4 from '../../Assets/11.b4c30e2abaee825d5424.png'
const Contet2Visssion = () => {
      const theme = useTheme();
    
     const matches2 = useMediaQuery(theme.breakpoints.up("sm"));
      let heading;
  return (
    <div style={{paddingTop:'3%',paddingBottom:"3%"}}
    id="vissionandmission">
      <Box sx={containerStyles4}>
        <Grid container spacing={4} >
          <Grid item xs={12} lg={6} md={6} sm={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} md={6} sm={6}>
                {/* Content for the first grid item */}
              </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
     
              <div data-aos="zoom-in">
                <img src={'https://img.freepik.com/premium-photo/three-pharmacists-working-pharmacy-checking-inventory-examining-medical-records_1361985-1148.jpg'} alt="" width="100%" />
              </div>
              </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
              <div data-aos="zoom-in">
                <img src={'https://img.freepik.com/free-photo/portrait-woman-working-pharmaceutical-industry_23-2151684905.jpg?t=st=1727341771~exp=1727345371~hmac=5db5bc7cd32092501dc2bdefd36a29050396e6a55fae4a1a1c343f46cc990386'} alt="" width="100%" />
           </div>   </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
          
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={6} md={6} sm={12} sx={{ margin: 'auto' }}>
          <div
                  data-aos="fade-left"
                  data-aos-offset="300"
                  data-aos-easing="ease-in-sine"
                >
          <TypographyText
              Typography={<>VISION
               
              </>}
              variant={matches2 ? "h5" : "h6"}
         
                textAlign="left"
                color ='white'
            />  
  <TypographyText
  Typography={
    <ul style={{ listStyleType: "disc", paddingLeft: "20px", color: "white" ,paddingBottom:'20px'}}>

      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
        <li>To be India’s leading access platform delivering timely, affordable, and life-saving biologics for rare and chronic diseases across India and emerging markets.</li>
      </ul>
    
     
    </ul>
  }
  textAlign="left"
  color="white"
/>
         <TypographyText
              Typography={<>MISSION
               
              </>}
              variant={matches2 ? "h5" : "h6"}
         
                textAlign="left"
                color ='white'
            />  
  <TypographyText
  Typography={
    <ul style={{ listStyleType: "disc", paddingLeft: "20px", color: "white",}}>

      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
       <li>To accelerate the availability of global innovations by partnering with world-class manufacturers, navigating complex regulatory paths, and ensuring equitable access for every patient who needs advanced therapies.</li>
      </ul>
    
     
    </ul>
  }
  textAlign="left"
  color="white"
/>
        </div>
          </Grid>
                    <Grid item xs={12} lg={6} md={6} sm={12} sx={{ margin: 'auto' }}>
          <div
                  data-aos="fade-left"
                  data-aos-offset="300"
                  data-aos-easing="ease-in-sine"
                >  <TypographyText
              Typography={<>GOALS
               
              </>}
              variant={matches2 ? "h5" : "h6"}
         
                textAlign="left"
                color ='white'
            />  
  <TypographyText
  Typography={
                  <ul style={{
                    listStyleType: "disc", paddingLeft: "20px", color: "white",
      paddingBottom:'20px'
     }}>
     
      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
      <li>Reduce time-to-market for critical biologics and rare-disease therapies.</li> <li>Build a sustainable access ecosystem by integrating awareness, affordability, and availability.</li> <li>Expand partnerships across India, the GCC, and South-East Asia with a patient-first approach.</li> <li>Enable institutions and governments to adopt high-impact treatments through scientific and operational excellence.</li>
      </ul>


 
    </ul>
  }
  textAlign="left"
  color="white"
/>
          {/* <TypographyText
              Typography={<>STRATEGIC PILLARS
               
              </>}
              variant={matches2 ? "h5" : "h6"}
         
                textAlign="left"
                color ='white'
            />  
  <TypographyText
  Typography={
    <ul style={{ listStyleType: "disc", paddingLeft: "20px", color: "white", }}>
     
      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
      <li>Patient Access: Deliver availability, affordability, and continuous treatment support.</li> <li>Partnerships: Collaborate with global innovators to bring advanced biologics to underserved markets.</li> <li>Regulatory Strength: Ensure streamlined dossier readiness, compliance, and fast market entry across India and the GCC.</li> <li>Scientific Excellence: Maintain strong medical, safety, and quality frameworks for responsible launch and scale-up.</li> <li>Awareness & Education: Strengthen early diagnosis and treatment adoption through clinician engagement and programs.</li>
      </ul>


 
    </ul>
  }
  textAlign="left"
  color="white"
/> */}
      
        </div>
          </Grid>
          
               <Grid item xs={12} lg={6} md={6} sm={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} md={6} sm={6}>
                {/* Content for the first grid item */}
              </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
     
              <div data-aos="zoom-in">
                <img src={img1} alt="" width="100%" />
              </div>
              </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
              <div data-aos="zoom-in">
                <img src={img2} alt="" width="100%" />
           </div>   </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
          
              </Grid>
            </Grid>
          </Grid>
                  <Grid item xs={12} lg={6} md={6} sm={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} md={6} sm={6}>
                {/* Content for the first grid item */}
              </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
     
              <div data-aos="zoom-in">
                <img src={img3} alt="" width="100%" />
              </div>
              </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
              <div data-aos="zoom-in">
                <img src={img4} alt="" width="100%" />
           </div>   </Grid>
              <Grid item xs={12} lg={6} md={6} sm={6}>
          
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={6} md={6} sm={12} sx={{ margin: 'auto' }}>
          <div
                  data-aos="fade-left"
                  data-aos-offset="300"
                  data-aos-easing="ease-in-sine"
                >
          <TypographyText
              Typography={<>STRATEGIC PILLARS
               
              </>}
              variant={matches2 ? "h5" : "h6"}
         
                textAlign="left"
                color ='white'
            />  
  <TypographyText
  Typography={
    <ul style={{ listStyleType: "disc", paddingLeft: "20px", color: "white", }}>
     
      <ul style={{ listStyleType: "circle", paddingLeft: "20px" }}>
      <li>Patient Access: Deliver availability, affordability, and continuous treatment support.</li> <li>Partnerships: Collaborate with global innovators to bring advanced biologics to underserved markets.</li> <li>Regulatory Strength: Ensure streamlined dossier readiness, compliance, and fast market entry across India and the GCC.</li> <li>Scientific Excellence: Maintain strong medical, safety, and quality frameworks for responsible launch and scale-up.</li> <li>Awareness & Education: Strengthen early diagnosis and treatment adoption through clinician engagement and programs.</li>
      </ul>


 
    </ul>
  }
  textAlign="left"
  color="white"
/>
        </div>
          </Grid>

        </Grid>
      </Box>
    </div>
  )
}

export default Contet2Visssion
